(function(){
  const CSS = `
/* form input overrides */
input#email,
input[data-testid="field-email"],
._formInputField_nag3b_7 {
  box-shadow: none !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
}

/* submit button override */
button[data-testid="btn-form-submit"],
._formSubmitButton_cit2d_96 {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0;
}
`;

  // id used to mark where we've injected
  const MARK = 'data-injected-by="form-overrides"';

  function alreadyInjectedRoot(root) {
    try {
      if (root instanceof Document) return !!root.head.querySelector(`style[${MARK}]`);
      if (root instanceof ShadowRoot || root instanceof Element) return !!root.querySelector(`style[${MARK}]`);
    } catch (e) {}
    return false;
  }

  function injectToRoot(root) {
    if (!root || alreadyInjectedRoot(root)) return false;

    // Document -> add to head
    if (root instanceof Document) {
      const s = document.createElement('style');
      s.setAttribute('data-injected-by','form-overrides');
      s.textContent = CSS;
      root.head.appendChild(s);
      return true;
    }

    // ShadowRoot -> prefer constructable stylesheet if supported
    if (root instanceof ShadowRoot) {
      try {
        if (window.CSSStyleSheet && Array.isArray(root.adoptedStyleSheets)) {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(CSS);
          root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
          return true;
        }
      } catch (e) { /* fallthrough to style fallback */ }

      const s = document.createElement('style');
      s.setAttribute('data-injected-by','form-overrides');
      s.textContent = CSS;
      root.appendChild(s);
      return true;
    }

    // Element -> append style inside element
    if (root instanceof Element) {
      const s = document.createElement('style');
      s.setAttribute('data-injected-by','form-overrides');
      s.textContent = CSS;
      root.appendChild(s);
      return true;
    }

    return false;
  }

  function styleContainer(container) {
    if (!container) return false;

    // if form is in light DOM under container
    const formLight = container.querySelector('form[data-testid="form"], form');
    if (formLight) {
      // If form is in light DOM, injecting to document head is fine
      const injected = injectToRoot(document);
      container.classList && container.classList.add('loaded');
      return injected;
    }

    // If container has a shadow root, look there
    if (container.shadowRoot) {
      const formShadow = container.shadowRoot.querySelector('form[data-testid="form"], form');
      if (formShadow) {
        const injected = injectToRoot(container.shadowRoot);
        container.classList && container.classList.add('loaded');
        return injected;
      }
    }

    return false;
  }

  // Style all current containers and shopify-forms-embed instances
  function styleAllExisting() {
    let found = false;
    const containers = Array.from(document.querySelectorAll('[data-form-root="true"], #app-embed, shopify-forms-embed'));
    containers.forEach(c => {
      if (styleContainer(c)) found = true;
    });

    // also try any shopify-forms-embed shadowRoots directly (in case they aren't marked)
    const embeds = Array.from(document.querySelectorAll('shopify-forms-embed'));
    embeds.forEach(e => {
      if (e.shadowRoot) {
        // avoid double-inject: check shadowRoot marker
        if (!alreadyInjectedRoot(e.shadowRoot) && e.shadowRoot.querySelector('form')) {
          injectToRoot(e.shadowRoot);
          found = true;
        }
      }
    });
    // If no containers found, we may still want document-level injection (optional)
    return found;
  }

  // Observe DOM for new embed containers or forms and apply styling
  function observeAndStyle() {
    const observer = new MutationObserver((mutations) => {
      // For performance, only scan on added nodes
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          // If a container or embed or form was added, attempt to style
          if (node.matches && node.matches('[data-form-root="true"], #app-embed, shopify-forms-embed, form')) {
            styleContainer(node) || styleAllExisting();
          } else {
            // also check descendants
            const found = node.querySelector && node.querySelector('[data-form-root="true"], #app-embed, shopify-forms-embed, form');
            if (found) styleAllExisting();
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // optional: stop observing after 30s to avoid long-lived observers
    setTimeout(() => observer.disconnect(), 30000);
  }

  // Run on DOM ready
  function init() {
    styleAllExisting();
    observeAndStyle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();